import { createRsaaAction } from "../../components/utilities/ReduxUtils";
import { IChemicalModel } from "../../data/ChemicalModel";
import type { WebSocketChempredictorSocketPredictPayload } from "../../data/models/schemas";
import { createSocketAction } from "../middlewares/websocket";
import type { IEstimateCompoundsResponse } from "../reducers/pocketbook";
import { refreshLicenseInfoMeta } from "../utils/meteringMeta";

export const CHEMPREDICTOR_PREDICT: string = "CHEMPREDICTOR_PREDICT";
export const CHEMPREDICTOR_SOCKET_PREDICT: string =
    "CHEMPREDICTOR_SOCKET_PREDICT";

// TODO(orval-drift): Orval ChemPredictorRequest/Response uses PocketbookFatModel for chemical payload.
export type IPredictStructureRequest = {
    smiles: string;
};

export type IPredictStructureResponse = {
    chemical: IChemicalModel;
};

export const predictStructure = createRsaaAction<
    IPredictStructureRequest,
    IPredictStructureResponse
>({
    path: "chempredictor/predict",
    method: "POST",
    type: CHEMPREDICTOR_PREDICT,
    meta: () => refreshLicenseInfoMeta,
});

export const predictStructureSocket = createSocketAction<
    WebSocketChempredictorSocketPredictPayload,
    IEstimateCompoundsResponse,
    IEstimateCompoundsResponse
>({
    type: CHEMPREDICTOR_SOCKET_PREDICT,
    meta: refreshLicenseInfoMeta,
});
